import { useState, useEffect } from 'react';

const useInstagramFeed = () => {
  const [feed, setFeed] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const accessToken = process.env.REACT_APP_INSTAGRAM_ACCESS_TOKEN;
  const userId = process.env.REACT_APP_INSTAGRAM_USER_ID;

  useEffect(() => {
    const fetchFeed = async () => {
      if (!accessToken || !userId) {
        setLoading(false);
        return; // Fallback to static images if no credentials
      }

      try {
        const url = `https://graph.instagram.com/${userId}/media?fields=id,caption,media_type,media_url,thumbnail_url,permalink&access_token=${accessToken}&limit=9`;
        const response = await fetch(url);
        
        if (!response.ok) {
          throw new Error(`Instagram API Error: ${response.statusText}`);
        }

        const data = await response.json();
        
        // Filter for IMAGE or CAROUSEL_ALBUM (and VIDEO if you want thumbnails)
        // For simplicity, we just take the data. 
        // Note: VIDEO media_type has a thumbnail_url field. IMAGE/CAROUSEL_ALBUM use media_url.
        const posts = data.data ? data.data.slice(0, 4) : []; // Limit to 4 to match design
        
        setFeed(posts);
      } catch (err) {
        console.error("Failed to fetch Instagram feed:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchFeed();
  }, [accessToken, userId]);

  return { feed, loading, error };
};

export default useInstagramFeed;
